import { render, staticRenderFns } from "./yhqx.vue?vue&type=template&id=31259b7d&"
import script from "./yhqx.vue?vue&type=script&lang=ts&"
export * from "./yhqx.vue?vue&type=script&lang=ts&"
import style0 from "./yhqx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports